import styled from "styled-components";
import { device } from "../../../../style";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 18px 16px;
  gap: 15px;
  width: 100%;

  @media ${device.mobileXL} {
    //  flex-direction: row;
  }

  @media ${device.tablet} {
    flex-direction: column;
    padding: 30px 30px 44px 30px;
  }
`;
